










import { Component, Mixins } from "vue-property-decorator";
import { default as MediaSelectableContentMixin } from "./mixins/MediaSelectableContentMixin.vue";
import { FileToBase64TextConverter } from "../../../FileToBase64TextConverter";
import { instanceOfIFixedTextIndicatable } from "../../../../../../domain/format";
import { FatalIndicator } from "./common";
import { IExecutable } from "./IExecutable";

@Component({
  components: {
    FatalIndicator,
  }
})
export default class WizardContentImageFileSelector extends Mixins(MediaSelectableContentMixin) implements IExecutable {
  $refs!: {
    input: HTMLInputElement
  };

  get text(): string {
    return instanceOfIFixedTextIndicatable(this.content)
      ? this.content.fixedText
      : "ファイル選択";
  }

  async execute() {
    this.$refs.input.click();
  }

  onFileChanged(e: Event) {
    const target = e.target as HTMLInputElement;
    if (target.files.length < 1) {
      return;
    }
    const file = target.files[0];
    if (!file || file.type.indexOf("image/") !== 0) {
      return;
    }
    FileToBase64TextConverter.convert(
      file,
      this.uploadImageFile,
      () => {
        this.$error(
          "画像変換失敗",
          "画像の変換に失敗しました。"
        );
    });
  }
}
